import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { getCargos } from "../../../../redux/actions/empleador";
import { validarCuilCuit } from "../../../../util/cuilcuit";
import ResponsablesEnum from "../../../enums/responsablesEnum";
import FormikActions from "../../formik/FormikActions";
import FormikTextField from "../../formik/FormikTextField";
import CircularLoading from "../../loading/CircularLoading";

const defaultInitialValues = {
    cargoEmpresa: null,
    apellidoNombre: "",
    cuil: "",
    telefono: "",
    email: "",
};

const validateNewContacto = Yup.object({
    apellidoNombre: Yup.string()
        .max(150, "Máximo 150 caracteres")
        .required("Campo obligatorio"),
    cuil: Yup.string()
        .matches(/^\d{11}$/, "El CUIL debe contener 11 dígitos numéricos")
        .required("Campo obligatorio")
        .test({
            name: "cuilValido",
            message: "Debe ingresar un CUIL válido",
            test: function (value) {
                if (value) {
                    return validarCuilCuit(value, true);
                }
            },
        }),
    telefono: Yup.string()
        .matches(
            /^[0-9()+\-\s]*$/,
            "Solo se permiten números y los caracteres ( ) + - y espacio"
        )
        .max(25, "El teléfono debe tener como máximo 25 caracteres")
        .required("Campo obligatorio"),
    email: Yup.string()
        .max(150, "Máximo 150 caracteres")
        .email("Ingrese una dirección de correo válida")
        .required("Campo obligatorio"),
});

const NewContactoDialog = ({ open, handleClose, handleSubmit, loading, initialValues: propInitialValues, isEditing }) => {
    const dispatch = useDispatch();

    const getInitialValues = () => {
        if (propInitialValues && isEditing) {
            return {
                apellidoNombre: (propInitialValues.nombreCompleto || "").replace(",", "").trim(),
                cuil: propInitialValues.cuit || "",
                telefono: propInitialValues.telefono || "",
                email: propInitialValues.email || "",
            };
        }

        return {
            ...defaultInitialValues,
        };
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>{isEditing ? "Editar Contacto" : "Nuevo Contacto"}</DialogTitle>
            <Formik
                initialValues={getInitialValues()}
                enableReinitialize
                onSubmit={(values) => {

                    dispatch(getCargos(ResponsablesEnum.contactoEmpresa))
                        .then((res) => {
                            let cargo = res?.value?.data;
                            handleSubmit({
                                ...values,
                                cargoEmpresa: cargo[0].id,
                            });
                        })
                }}
                validationSchema={validateNewContacto}
            >
                {() => (
                    <Form>
                        <DialogContent>
                            {loading ? (
                                <CircularLoading />
                            ) : (
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            name="apellidoNombre"
                                            label="Apellido y Nombre *"
                                            type="text"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            name="cuil"
                                            label="CUIL *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            name="telefono"
                                            label="Teléfono *"
                                            type="text"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            name="email"
                                            label="Mail *"
                                            type="text"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default NewContactoDialog;
